import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

import {AttributePermission, GroupAttributePermission} from '../types';

/**
 * `setAttributePermissions` request params
 * (what is used to send to server)
 */
export type SetAttributePermissionsRequestOptions = {
	templateId: AttributePermission['templateId'];
	groupAttributePermissions: GroupAttributePermission[];
};

/**
 * `setAttributePermissions` request
 * (what gets sent to the server)
 */
export type SetAttributePermissionsRequest = [
	SetAttributePermissionsRequestOptions['templateId'],
	SetAttributePermissionsRequestOptions['groupAttributePermissions'],
];

/**
 * `setAttributePermissions` response
 * (what comes back from the server)
 */
export type SetAttributePermissionsResponse =
	SuccessResponse<SetAttributePermissionsResult>;

/**
 * `setAttributePermissions` result
 * (what is utilized from the server response)
 */
export type SetAttributePermissionsResult = AttributePermission[];

export const setAttributePermissionsEndpoint = 'setAttributePermissions';

/**
 * Set attribute permissions
 */
export const setAttributePermissions = async ({
	groupAttributePermissions,
	templateId,
}: SetAttributePermissionsRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: SetAttributePermissionsRequest = [
		templateId,
		groupAttributePermissions,
	];

	return client
		.post<SetAttributePermissionsResponse>(
			setAttributePermissionsEndpoint,
			requestParams,
		)
		.then((response) => response.data.result);
};

export default setAttributePermissions;
